var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("quote-builder-misc-item-template", {
    staticClass: "bb-grey-1 pb-2 mb-2 quote-item-heading",
    class: `quote-item-heading-${_vm.$theme.name}`,
    attrs: { "is-full-width": _vm.isFullWidth, "is-heading": true },
    scopedSlots: _vm._u([
      {
        key: "description",
        fn: function () {
          return [
            _c("div", { staticClass: "is-flex is-align-items-center" }, [
              _c("span", [_vm._v(_vm._s(_vm.name))]),
              _c("span", { staticClass: "ml-2" }, [
                _vm._v("(" + _vm._s(_vm.count) + ")"),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "rates",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-end is-align-items-center mx-2",
              },
              [_vm.count >= 1 ? _c("span", [_vm._v("Type")]) : _vm._e()]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "report_blend",
        fn: function () {
          return [
            _c("div", {}, [false ? _c("span", [_vm._v("Rpt")]) : _vm._e()]),
          ]
        },
        proxy: true,
      },
      {
        key: "hour_value",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-end is-align-items-center mx-2",
              },
              [_vm.count >= 1 ? _c("span", [_vm._v("QTY")]) : _vm._e()]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "total_value",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-end is-align-items-center",
              },
              [
                _vm.count >= 1
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.totalAmount,
                            _vm.$userInfo.locale,
                            2
                          )
                        )
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }